import type { IconProps } from './types/types';
import IconWrapper from './wrapper/SvgIconWrapper';

const MinusSquareInsideIcon = (props: IconProps) => {
  return (
    <IconWrapper {...props}>
      <path d="M5.125 8.5H10.875C10.9438 8.5 11 8.44375 11 8.375V7.625C11 7.55625 10.9438 7.5 10.875 7.5H5.125C5.05625 7.5 5 7.55625 5 7.625V8.375C5 8.44375 5.05625 8.5 5.125 8.5Z" />
    </IconWrapper>
  );
};

export default MinusSquareInsideIcon;
